import { useState } from 'react';
import { Modal } from '../components/Modal';

// Fase 25B: dialogo de confirmacion CON motivo (10-500) para acciones sensibles (suspender/archivar).
// Reemplaza window.prompt por un modal accesible y consistente (24B).
export function ReasonDialog({ title, description, confirmLabel, danger, busy, onCancel, onConfirm }: {
  title: string;
  description: string;
  confirmLabel: string;
  danger?: boolean;
  busy: boolean;
  onCancel: () => void;
  onConfirm: (reason: string) => void;
}) {
  const [reason, setReason] = useState('');
  const valid = reason.trim().length >= 10 && reason.trim().length <= 500;
  return (
    <Modal
      title={title}
      isBusy={busy}
      onClose={onCancel}
      footer={<>
        <button className="button button--ghost" disabled={busy} onClick={onCancel} type="button">Cancelar</button>
        <button className={`button ${danger ? 'button--danger' : 'button--primary'}`} disabled={busy || !valid} onClick={() => onConfirm(reason.trim())} type="button">{confirmLabel}</button>
      </>}
    >
      <p className="platform-muted">{description}</p>
      <label className="field"><span>Motivo * (10–500 caracteres)</span>
        <textarea value={reason} rows={3} maxLength={500} onChange={(e) => setReason(e.target.value)} autoFocus />
      </label>
    </Modal>
  );
}
